<template>
  <div class="health-dashboard-container">
    <!-- 左侧图表区域 -->
    <div class="dashboard-left">
      <!-- 饮食记录 -->
      <DietRecord
        :food-list="dietList"
        :fasting-list="fastingFoodList"
        :fasting-count="fastingFoodCount"
        :active-tab="dietType"
        :total-count="dietTotalCount"
        @tab-change="(tab) => handleTabChange('diet', tab)"
      />

      <!-- 运动记录 -->
      <ExerciseRecord
        :exercise-list="exerciseList"
        :active-tab="sportType"
        :stats="exerciseStats"
        @tab-change="(tab) => handleTabChange('sport', tab)"
      />

      <!-- 睡眠记录 - 传递原始数据数组 -->
      <SleepRecord
        :sleep-data="sleepRawData"
        :active-tab="sleepType"
        @tab-change="(tab) => handleTabChange('sleep', tab)"
      />

      <!-- 按摩记录 -->
      <MassageRecord
        :acupoint-list="massageList"
        :active-tab="massageType"
        :total-count="massageTotalCount"
        @tab-change="(tab) => handleTabChange('massage', tab)"
      />
    </div>

    <!-- 右侧数字人区域 -->
    <div class="digital-human-section">
      <!-- 渐变圆环背景 -->
      <div class="circle-background" />

      <!-- 数字人形象 -->
      <div class="digital-human-container">
        <img v-if="sexsign != 1" src="@/assets/icon/numwuman.png" alt="数字人" class="digital-human-img">
        <img v-if="sexsign == 1" src="@/assets/icon/numman.png" alt="数字人" class="digital-human-img">
      </div>

      <!-- 提示气泡 -->
      <div class="chat-bubble" @click="viewConstitutionReport">
        <div class="bubble-arrow" />
        <p class="bubble-text">我是{{ tizhi.name }}，请点击查看我的体质报告</p>
      </div>
    </div>

    <!-- 体质报告弹窗 -->
    <el-dialog
      title="体质报告"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="true"
      custom-class="constitution-dialog"
      append-to-body
    >
      <div class="constitution-content" v-html="constitutionContent" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 积分明细弹窗 -->
    <el-dialog
      title="积分明细"
      :visible.sync="pointsDialogVisible"
      width="600px"
      :close-on-click-modal="true"
      custom-class="points-dialog"
      append-to-body
    >
      <div class="points-table-container">
        <el-table
          v-loading="!countIntegralList.length"
          :data="countIntegralList"
          stripe
          style="width: 100%"
          height="400px"
        >
          <el-table-column
            prop="pointsLogDesc"
            label="事件"
            min-width="200"
            show-overflow-tooltip
          />
          <el-table-column
            prop="integralChange"
            label="积分变动"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span :class="scope.row.integralChange >= 0 ? 'points-plus' : 'points-minus'">
                {{ scope.row.integralChange >= 0 ? '+' : '' }}{{ scope.row.integralChange }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="时间"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime ? new Date(scope.row.createTime).toLocaleString('zh-CN') : '' }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="totalCount"
          @current-change="handlePointsPageChange"
        />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pointsDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DietRecord from './DietRecord.vue'
import ExerciseRecord from './ExerciseRecord.vue'
import SleepRecord from './SleepRecord.vue'
import MassageRecord from './MassageRecord.vue'
import { postData, integral } from "@/api/user/authApi"
import { getfindByCode } from '@/api/ik/data/health'
import shiwuList from './shiwu.json'
const foodNameToCodeMap = {}
shiwuList.forEach(item => {
  foodNameToCodeMap[item.name] = item.code
})
// 补充多名称映射（比如"肥猪肉"和"肥肉"都对应feirou）
shiwuList.forEach(item => {
  if (!foodNameToCodeMap[item.name]) {
    foodNameToCodeMap[item.name] = item.code
  }
})
export default {
  name: 'HealthDashboard',
  components: {
    DietRecord,
    ExerciseRecord,
    SleepRecord,
    MassageRecord
  },
  props: {
    userCode: {
      type: String,
      default: ''
    },
    sexsign: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      countIntegral: 0,
      countIntegralList: [],
      // 积分明细弹窗
      pointsDialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      // 体质报告弹窗
      dialogVisible: false,
      constitutionContent: '',
      tizhi: {},
      // 饮食数据
      dietType: '3',
      dietList: [],
      fastingFoodList: [],
      dietTotalCount: 0,
      fastingFoodCount: 0,
      // 运动数据
      sportType: '3',
      exerciseList: [],
      exerciseStats: { totalCount: 0, standard: 0, notStandard: 0 },
      // 睡眠数据 - 改为存储原始记录数组
      sleepType: '3',
      sleepRawData: [], // 原始记录数组，包含 typeTab 字段
      // 按摩数据
      massageType: '3',
      massageList: [],
      massageTotalCount: 0
    }
  },
  watch: {
    userCode: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.trim() !== '') {
          this.loadAllData()
        } else {
          this.clearAllData()
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    // 加载所有数据
    loadAllData() {
      if (!this.userCode) return
      this.getfoodrecord(this.dietType)
      this.getsportrecord(this.sportType)
      this.getsleeprecord(this.sleepType)
      this.getmassagerecord(this.massageType)
      this.getPhydiagrecord()
    },

    // 清空数据
    clearAllData() {
      this.dietList = []
      this.dietTotalCount = 0
      this.exerciseList = []
      this.exerciseStats = { totalCount: 0, standard: 0, notStandard: 0 }
      this.sleepRawData = []
      this.massageList = []
      this.massageTotalCount = 0
      this.tizhi = {}
      this.countIntegral = 0
      this.countIntegralList = []
    },

    // 获取体质信息
    getPhydiagrecord() {
      const pd = {
        "userCode": this.userCode,
        "storeCode": "CS00001"
      }
      postData('health/diagnosis/physique/phydiagrecord/find/findphyrecord', pd).then(response => {
        if (response.data) {
          this.tizhi = response.data
        }
      })
    },

    // Tab切换处理
    handleTabChange(chartType, tab) {
      const typeMap = { '1': '1', '2': '2', '3': '3' }
      const type = typeMap[tab] || "3"

      switch (chartType) {
        case 'diet':
          this.dietType = type
          this.getfoodrecord(type)
          break
        case 'sport':
          this.sportType = type
          this.getsportrecord(type)
          break
        case 'sleep':
          this.sleepType = type
          this.getsleeprecord(type)
          break
        case 'massage':
          this.massageType = type
          this.getmassagerecord(type)
          break
      }
    },

    // 获取积分
    getintegral(page = 1) {
      const pd = {
        page: page,
        limit: this.pageSize,
        userCode: this.userCode
      }
      integral('user/pointsLog/integral/detail', pd).then(res => {
        if (res.data) {
          this.countIntegral = res.data.countIntegral || 0
          this.countIntegralList = res.data.pageInfoS?.list || []
          this.totalCount = res.data.pageInfoS?.totalCount || 0
          this.currentPage = page
        }
      })
    },

    // 打开积分明细弹窗
    openPointsDialog() {
      this.pointsDialogVisible = true
      this.currentPage = 1
      this.getintegral(1)
    },

    // 分页变化处理
    handlePointsPageChange(page) {
      this.getintegral(page)
    },

    // 查看体质报告
    viewConstitutionReport() {
      this.getcontentlist()
    },

    // 获取体质报告内容
    getcontentlist() {
      const pd = {
        phyTypeCode: this.tizhi.code,
        storeCode: "CS00001",
        sexSign: this.sexsign.toString()
      }
      const params = {
        code: ''
      }
      postData('health/diagnosis/physique/phydiagrecord/find/getdefaultcontent', pd).then(res => {
        params.code = res.data.contentInfoCode
        getfindByCode('', params).then(res => {
          this.constitutionContent = res.data.head.htmlContent || ''
          this.dialogVisible = true
        }).catch(() => {
          this.$message.error('获取体质报告失败')
        })
      }).catch(() => {
        this.$message.error('获取体质信息失败')
      })
    },

    // 工具方法：格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 获取日期列表
    generateDateList(type) {
      const baseDate = new Date()
      let fullDates = []
      if (type === "2") {
        fullDates = this.getWeekDates(baseDate)
      } else if (type === "3") {
        fullDates = this.getMonthDates(baseDate.getFullYear(), baseDate.getMonth())
      } else {
        fullDates = [this.formatDate(baseDate)]
      }
      return fullDates
    },

    getWeekDates(baseDate) {
      const dates = []
      const day = baseDate.getDay()
      const monday = new Date(baseDate)
      monday.setDate(baseDate.getDate() - (day === 0 ? 6 : day - 1))
      for (let i = 0; i < 7; i++) {
        const date = new Date(monday)
        date.setDate(monday.getDate() + i)
        dates.push(this.formatDate(date))
      }
      return dates
    },

    getMonthDates(year, month) {
      const dates = []
      const lastDay = new Date(year, month + 1, 0).getDate()
      for (let d = 1; d <= lastDay; d++) {
        const date = new Date(year, month, d)
        dates.push(this.formatDate(date))
      }
      return dates
    },

    // 获取饮食记录
    getfoodrecord(type) {
      if (!this.userCode) return

      // 从shiwu.json映射表中获取食物对应的code，进而拼接图片路径
      const getConstitutionImage = (name) => {
        if (!name) return ''
        // 遍历食物名称，匹配包含关系（比如name包含"生姜"则取生姜的code）
        const matchedFood = shiwuList.find(item => name.includes(item.name))
        if (matchedFood) {
          try {
            return require(`@/assets/shiwu/${matchedFood.code}.png`)
          } catch (e) {
            console.warn(`未找到体质图片: ${matchedFood.code}.png`)
            return ''
          }
        }
        return ''
      }

      postData('health/health/record/foodrecord/find/statsfoodrecord', {
        "userCode": this.userCode,
        "type": type
      }).then(res => {
        const records = res.data?.record || []
        const fastingFoodMap = res.data?.fastingFood || {}

        const fastingFoodCount = records.filter(item =>
          item.fastingFoodContent && item.fastingFoodContent.trim() !== ''
        ).length

        if (type === '1') {
          const today = this.formatDate(new Date())
          const todayRecords = records.filter(item => {
            const timestamp = Number(item.recordDate)
            const date = new Date(timestamp > 1e10 ? timestamp : timestamp * 1000)
            return this.formatDate(date) === today
          })

          const todayFastingFoods = todayRecords.filter(item =>
            item.fastingFoodContent && item.fastingFoodContent.trim() !== ''
          )

          this.dietList = todayFastingFoods.map(item => ({
            name: item.foodContent || '未知食物',
            count: 1,
            image: item.foodImg || '',
            tags: [{ label: '忌口', color: '#FF6B6B' }]
          }))

          if (this.dietList.length === 0 && Object.keys(fastingFoodMap).length > 0) {
            this.dietList = Object.keys(fastingFoodMap).map(foodName => ({
              name: foodName,
              count: 0,
              image: '',
              tags: [{ label: '忌口', color: '#FF6B6B' }]
            }))
          }
          this.dietTotalCount = todayFastingFoods.length
        } else {
          const fastingFoodList = Object.keys(fastingFoodMap).map(foodName => ({
            name: foodName,
            count: fastingFoodMap[foodName] || 0,
            image: getConstitutionImage(foodName), // 改用新的图片获取逻辑
            tags: [{ label: '忌口', color: '#FF6B6B' }]
          })).sort((a, b) => b.count - a.count).slice(0, 4)

          this.dietList = fastingFoodList
          console.log(this.dietList)

          this.dietTotalCount = Object.values(fastingFoodMap).reduce((sum, count) => sum + count, 0) || fastingFoodCount
        }
      })
    },

    // 获取运动记录
    getsportrecord(type) {
      if (!this.userCode) return
      const constitutionMap = [
        { name: '单杠悬垂(轻度)', code: 'DGCX' },
        { name: '扶椅抬腿', code: 'FYTT' },
        { name: '太极拳', code: 'TJQ' },
        { name: '五禽戏', code: 'WQX' },
        { name: '散步', code: 'SB' },
        { name: '快走', code: 'KZ' },
        { name: '公园健步', code: 'GYJB' },
        { name: '易筋经', code: 'YJJ' },
        { name: '靠墙静蹲', code: 'KQJD' },
        { name: '弹力带拉伸', code: 'TLDLS' },
        { name: '买菜/做家务', code: 'MC' },
        { name: '园艺/浇花', code: 'YY' },
        { name: '带孙玩耍', code: 'DSWS' }
      ]

      // 根据名称获取对应体质图片
      const getConstitutionImage = (name) => {
        console.log(name)

        if (!name) return ''
        for (const item of constitutionMap) {
          if (name.includes(item.name)) {
            try {
              return require(`@/assets/yundong/${item.code}.png`)
            } catch (e) {
              console.warn(`未找到体质图片: ${item.code}.png`)
              return ''
            }
          }
        }
        return ''
      }
      postData('health/health/record/sportrecord/find/statsmotionrecord', {
        "userCode": this.userCode,
        "type": type
      }).then(res => {
        const records = res.data?.record || []
        let standard = 0
        let notStandard = 0

        records.forEach(item => {
          if (item.typeTab === '不达标') {
            notStandard++
          } else {
            standard++
          }
        })

        this.exerciseStats = {
          totalCount: records.length,
          standard: standard,
          notStandard: notStandard
        }

        const motionData = res.data?.motion || {}

        this.exerciseList = Object.keys(motionData).map(name => ({
          name: name,
          time: motionData[name] || 0,
          image: getConstitutionImage(name),
          count: 1
        })).sort((a, b) => b.time - a.time).slice(0, 4)
      }).catch(() => {
        this.exerciseList = []
        this.exerciseStats = { totalCount: 0, standard: 0, notStandard: 0 }
      })
    },

    // 获取睡眠记录 - 保存原始记录数组
    getsleeprecord(type) {
      if (!this.userCode) return
      postData('health/health/record/sleeprecord/find/statssleeprecord', {
        "userCode": this.userCode,
        "type": type
      }).then(res => {
        const records = Array.isArray(res.data) ? res.data : []

        // 保存原始记录数组，包含 typeTab 字段
        this.sleepRawData = records
      }).catch(() => {
        this.sleepRawData = []
      })
    },

    // 获取按摩记录
    getmassagerecord(type) {
      if (!this.userCode) return

      // 体质图片映射配置
      const constitutionMap = [
        { name: '足三里,合谷', code: 'PHZ' },
        { name: '足三里,气海,关元', code: 'QXZ' },
        { name: '足三里,命门,关元', code: 'YANGXZ' }, // 首字全拼
        { name: '三阴交,太溪,涌泉', code: 'YINXZ' }, // 首字全拼
        { name: '足三里,丰隆,阴陵泉', code: 'TSZ' },
        { name: '曲池,太冲,阴陵泉', code: 'SRZ' },
        { name: '血海,合谷,三阴交', code: 'XYZ' },
        { name: '太冲,合谷,内关', code: 'QYZ' },
        { name: '足三里,曲池,肺俞', code: 'TBZ' }
      ]

      // 根据名称获取对应体质图片
      const getConstitutionImage = (name) => {
        if (!name) return ''
        for (const item of constitutionMap) {
          if (name.includes(item.name)) {
            try {
              return require(`@/assets/tizhi/${item.code}.jpg`)
            } catch (e) {
              console.warn(`未找到体质图片: ${item.code}.jpg`)
              return ''
            }
          }
        }
        return ''
      }

      postData('health/health/record/massagerecord/find/statsmassagerecord', {
        "userCode": this.userCode,
        "type": type
      }).then(res => {
        // 优先使用 massageCount 对象 {"按摩项目": 次数}
        const massageCount = res.data?.massageCount || {}

        // 将对象转换为数组格式，并匹配体质图片
        this.massageList = Object.keys(massageCount).map(name => ({
          name: name,
          count: massageCount[name],
          image: getConstitutionImage(name),
          label: ''
        })).sort((a, b) => b.count - a.count).slice(0, 4)

        // 计算总次数
        this.massageTotalCount = Object.values(massageCount).reduce((sum, count) => sum + count, 0)

        // 如果 massageCount 为空，降级使用 record 数组（兼容逻辑）
        if (Object.keys(massageCount).length === 0) {
          const records = res.data?.record || []
          const massageCountMap = {}

          records.forEach(item => {
            const typeName = item.massageTypeName || '按摩'
            massageCountMap[typeName] = (massageCountMap[typeName] || 0) + 1
          })

          this.massageList = Object.keys(massageCountMap).map(name => ({
            name,
            count: massageCountMap[name],
            image: getConstitutionImage(name),
            label: ''
          })).sort((a, b) => b.count - a.count).slice(0, 4)

          this.massageTotalCount = records.length
        }
      }).catch(() => {
        this.massageList = []
        this.massageTotalCount = 0
      })
    }
  }
}
</script>

<style scoped>
.health-dashboard-container {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: #f5f7fa;
  width: 100%;
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

/* 左侧图表区域 */
.dashboard-left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 右侧数字人区域 */
.digital-human-section {
  width: 140px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  background: #fff;
  border-radius: 12px;
  position: relative;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 渐变圆环背景 */
.circle-background {
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: linear-gradient(135deg, #CFDDFB 0%, #E0F9E9 100%);
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 1;
  pointer-events: none;
  opacity: 0.4;
  -webkit-mask: radial-gradient(circle, transparent 55%, black 55%);
  mask: radial-gradient(circle, transparent 55%, black 55%);
}

/* 积分徽章 */
.points-badge {
  position: absolute;
  left: -10px;
  top: 12%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #636FCF;
  box-shadow:
    inset 0 2px 6px rgba(135, 206, 235, 0.6),
    inset 0 -1px 4px rgba(255, 255, 255, 0.8),
    0 2px 6px rgba(0, 0, 0, 0.08);
  z-index: 10;
  backdrop-filter: blur(4px);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.points-badge:hover {
  transform: translateY(-50%) scale(1.05);
  box-shadow:
    inset 0 2px 6px rgba(135, 206, 235, 0.8),
    inset 0 -1px 4px rgba(255, 255, 255, 0.9),
    0 4px 12px rgba(99, 111, 207, 0.3);
}

.points-value {
  font-weight: bold;
  font-size: 15px;
  line-height: 1;
  margin-bottom: 2px;
}

.points-label {
  font-size: 12px;
  opacity: 0.9;
}

/* 数字人容器 */
.digital-human-container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 5;
  margin-top: 60px;
}

.digital-human-img {
  width: 100px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.1));
}

/* 提示气泡 */
.chat-bubble {
  background: white;
  border-radius: 12px;
  padding: 10px 12px;
  max-width: 120px;
  box-shadow:
    inset 0 2px 6px rgba(116, 178, 253, 0.8),
    0 3px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: float 3s ease-in-out infinite;
  position: relative;
  z-index: 5;
  margin-top: 16px;
}

.chat-bubble:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.bubble-text {
  margin: 0;
  font-size: 12px;
  color: #3177F1;
  line-height: 1.4;
  font-weight: 500;
  text-align: center;
}

/* 气泡箭头 */
.bubble-arrow {
  position: absolute;
  top: -6px;
  right: 24px;
  width: 12px;
  height: 6px;
  background: white;
  box-shadow: inset 0 2px 6px rgba(116, 178, 253, 0.6);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

/* 浮动动画 */
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

/* 弹窗样式 */
.constitution-dialog >>> .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px;
}

.constitution-content {
  line-height: 1.8;
  color: #333;
  font-size: 14px;
}

.constitution-content >>> img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 10px 0;
}

.constitution-content >>> p {
  margin: 10px 0;
  text-align: justify;
}

.constitution-content >>> h1,
.constitution-content >>> h2,
.constitution-content >>> h3 {
  color: #2c3e50;
  margin: 16px 0 12px 0;
  font-weight: 600;
}

.points-dialog >>> .el-dialog__body {
  padding: 20px 20px 10px 20px;
}

.points-table-container {
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
}

.points-plus {
  color: #67c23a;
  font-weight: 600;
}

.points-minus {
  color: #f56c6c;
  font-weight: 600;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}

/* 响应式适配 */
@media screen and (max-width: 900px) {
  .health-dashboard-container {
    flex-direction: column;
  }

  .digital-human-section {
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    gap: 20px;
  }

  .circle-background {
    width: 200px;
    height: 200px;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .digital-human-container {
    margin-top: 0;
  }

  .points-badge {
    position: relative;
    left: auto;
    top: auto;
    transform: none;
  }

  .chat-bubble {
    margin-top: 0;
    max-width: 150px;
  }
}
</style>
